import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/aquarist/www/prod/layouts/default.vue")),
  "home-layout": defineAsyncComponent(() => import("/home/aquarist/www/prod/layouts/home-layout.vue")),
  "shop-layout": defineAsyncComponent(() => import("/home/aquarist/www/prod/layouts/shop-layout.vue"))
}